module.exports = __webpack_public_path__ + "static/img/c82dcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/qhRecommendOpenAccount/images/logo.png
// module id = 257
// module chunks = 2